//引入AxiosReques
import axiosApi from '@/utils/AxiosReques'

/**
 * @description 登录
 * @returns Promise
 */
export const reqToken = (params) => axiosApi.post('/api/Login/signin', params)

/**
 * @description 退出登录
 * @returns Promise
 */
export const reqLogout = () => axiosApi.post('/api/Login/logOut')


/**
 * @description 获取用户信息
 * @returns Promise
 */
export const reqUserInofo = () => axiosApi.post('/api/Getinfo/getUsers')


/**
 * @description 是否关注公众号
 * @returns Promise
 */
export const subscribe = (params) => axiosApi.post('/api/Getinfo/is_subscribe', params)


/**
 * @description 修改电话号码
 * @returns Promise
 */
export const reqChangePhone = (params) => axiosApi.post('/api/Getinfo/editPhone', params)

/**
 * @description 搜索用户信息
 * @returns Promise
 * @params 吉祥号
 */
export const reqSearchUser = (params) => axiosApi.post('/api/Getinfo/searchTeam', params)

/**
 * @description 添加队员
 * @returns Promise
 * @params 吉祥号
 */
export const reqaddTeam = (params) => axiosApi.post('/api/Getinfo/addTeam', params)


/**
 * @description 切换账号
 * @returns Promise
 * @params aid
 */
export const reqswitchAccounts = (params) => axiosApi.post('/api/Getinfo/switchAccounts', params)


/**
 * @description 删除队员
 * @returns Promise
 * @params aid
 */
export const reqdelTeam = (params) => axiosApi.post('/api/Getinfo/delTeam', params)

/**
 * @description 设置管理员
 * @returns Promise
 * @params teamId
 */
export const reqsetTeamAdmin = (params) => axiosApi.post('/api/Getinfo/setTeamAdmin', params)

/**
 * @description 退出团队
 * @returns Promise
 * @params teamId
 */
export const reqexitTeam = (params) => axiosApi.post('/api/Getinfo/exitTeam', params)

/**
 * @description 获取专利信息
 * @returns Promise
 * @params 搜索信息
 */
export const reqPatentInofo = (params) => axiosApi.post('/api/Patentapi/getPatentInofo', params)

/**
 * @description 添加监控
 * @returns Promise
 * @params 搜索信息
 */
export const reqaddPatentData = (params) => axiosApi.post('/api/Patentapi/addPatentData', params)

/**
 * @description 待更新
 * @returns Promise
 * @params 搜索信息
 */
export const reqMonitor = (params) => axiosApi.post(`/api/Monitor/index?p=${params.page}`, params)

/**
 * @description 全部
 * @returns Promise
 * @params 搜索信息
 */
export const reqMonitorAll = (params) => axiosApi.post(`/api/Monitor/all?p=${params.page}`, params)
/**
 * @description 正常
 * @returns Promise
 * @params 搜索信息
 */
export const reqMonitornormal = (params) => axiosApi.post(`/api/Monitor/normal?p=${params.page}`, params)

/**
 * @description 过期
 * @returns Promise
 * @params 搜索信息
 */
export const reqMonitorexpired = (params) => axiosApi.post(`/api/Monitor/expired?p=${params.page}`, params)

/**
 * @description 失效
 * @returns Promise
 * @params 搜索信息
 */
export const reqMonitorinvalid = (params) => axiosApi.post(`/api/Monitor/invalid?p=${params.page}`, params)

/**
 * @description 回收站
 * @returns Promise
 * @params 搜索信息
 */
export const reqMonitorrecycleBin = (params) => axiosApi.post(`/api/Monitor/recycleBin?p=${params.page}`, params)

/**
 * @description 删除监控
 * @returns Promise
 * @params id
 */
export const reqdelMonitor = (params) => axiosApi.post(`/api/Monitor/delMonitor`, params)


/**
 * @description 恢复监控
 * @returns Promise
 * @params id
 */
export const reqrestoreMonitor = (params) => axiosApi.post(`/api/Monitor/restoreMonitor`, params)

/**
 * @description 永久删除
 * @returns Promise
 * @params id
 */
export const reqpermanentlyDelMonitor = (params) => axiosApi.post(`/api/Monitor/permanentlyDelMonitor`, params)

/**
 * @description 自动更新
 * @returns Promise
 * @params 搜索信息
 */
export const reqMonitorautoUp = (params) => axiosApi.post(`/api/Monitor/autoUp?p=${params.page}`, params)

/**
 * @description 同步单条数据
 * @returns Promise
 * @params 搜索信息
 */
export const reqfirstUpdate = (params) => axiosApi.post(`/api/Patentapi/first_update`, params)

/**
 * @description 获取专利详情
 * @returns Promise
 * @params id
 */
export const reqPatentDetails = (params) => axiosApi.post(`/api/Monitor/PatentDetails`, params)

/**
 * @description 重新更新数据
 * @returns Promise
 * @params id
 */
export const reqAgainUpdate = (params) => axiosApi.post(`/api/Patentapi/again_update`, params)

/**
 * @description 本期已缴费 自动缴费
 * @returns Promise
 * @params id
 */
export const reqsetAutoup = (params) => axiosApi.post(`/api/Monitor/setAutoup`, params)

/**
 * @description 本期已缴费 取消自动缴费
 * @returns Promise
 * @params id
 */
export const reqrevokeAutoup = (params) => axiosApi.post(`/api/Monitor/revokeAutoup`, params)

/**
 * @description 更新专利
 * @returns Promise
 * @params id
 */
export const requpdata = (params) => axiosApi.post(`/api/Patentapi/first_update`, params)

/**
 * @description 获取吉祥币信息
 * @returns Promise
 * @params id
 */
export const getGlobalInfos = (params) => axiosApi.post(`/api/Monitor/getGlobalInfos`, params)

/**
 * @description 交易记录
 * @returns Promise
 * @params id
 */
export const transactionRecord = (params) => axiosApi.post(`/api/Getinfo/transactionRecord?p=${params.page}`, params)

/**
 * @description 充值记录
 * @returns Promise
 * @params id
 */
export const payLog = (params) => axiosApi.post(`/api/Getinfo/payLog?p=${params.page}`, params)

/**
 * @description 免费->领取吉祥币
 * @returns Promise
 * @params id
 */
export const freeReceive = (params) => axiosApi.post(`/api/Getinfo/free_receive?`, params)

/**
 * @description 免费->领取吉祥币
 * @returns Promise
 * @params id
 */
export const weixinpay = (params) => axiosApi.post(`/api/Pay/Pay?`, params)

/**
 * @description 支付结果查询
 * @returns Promise
 * @params 订单号
 */
export const askPay = (params) => axiosApi.post(`/api/Notify/askPay?`, params)


/**
 * @description 获取移动端信息
 * @returns Promise
 */
export const getList = () => axiosApi.post('/api/Webapi/aboutCus')

/**
 * @description 委托缴费
 * @returns Promise
 * @params id
 */
export const entrustedPayment = (params) => axiosApi.post(`/api/Monitor/entrustedPayment`, params)

/**
 * @description 年费代缴-委托明细
 * @returns Promise
 * @params id
 */
export const getAnnualSettlement = (params) => axiosApi.post(`/api/Bill/getAnnualSettlement?p=${params.page}`, params)

/**
 * @description 年费代缴-删除委托明细
 * @returns Promise
 * @params id
 */
export const delAnnualSettlementPrice = (params) => axiosApi.post(`/api/Bill/delAnnualSettlementPrice?p=${params.page}`, params)

/**
 * @description 获取标识卡信息
 * @returns Promise
 * @params id
 */
export const getSignInfo = (params) => axiosApi.post(`/api/Monitor/getSignInfo?p=${params.page}`, params)

/**
 * @description 获取标识卡信息
 * @returns Promise
 * @params id
 */
export const setBindSign = (params) => axiosApi.post(`/api/Monitor/setBindSign`, params)


/**
 * @description 重新召唤
 * @returns Promise
 * @params id
 */
export const summon_again = (params) => axiosApi.post(`/api/Getinfo/summon_again`, params)

/**
 * @description 销毁Aicode
 * @returns Promise
 * @params id
 */
export const delAiCode = (params) => axiosApi.post(`/api/Getinfo/delAiCode`, params)

/**
 * @description 检索记录
 * @returns Promise
 * @params id
 */
export const QueryRecord = (params) => axiosApi.post(`/api/Getinfo/QueryRecord?p=${params.page}`, params)

/**
 * @description 编辑账号集信息
 * @returns Promise
 * @params id
 */
export const editAccount = (params) => axiosApi.post(`/api/Getinfo/editAccount`, params)

/**
 * @description 批量加入监控
 * @returns Promise
 * @params id
 */
export const addPatentDatas = (params) => axiosApi.post(`/api/Patentapi/addPatentDatas`, params)


/**
 * @description 导出excel筛选
 * @returns Promise
 * @params id
 */
export const yunSearch = (params) => axiosApi.post(`/api/Getinfo/yunSearch`, params)


/**
 * @description 下载数据前的统计
 * @returns Promise
 * @params id
 */
export const downloadDataCount = (params) => axiosApi.post(`/api/Getinfo/downloadDataCount `, params)


/**
 * @description 首次批量更新数据（队列同步）
 * @returns Promise
 * @params id
 */
export const queueSync = (params) => axiosApi.post(`/api/Patentapi/queueSync `, params)



/**
 * @description 查询更新任务
 * @returns Promise
 * @params id
 */
export const queueSyncTask = (params) => axiosApi.post(`/api/Patentapi/testTaskState `, params)

/**
 * @description 统计更新全部的数量
 * @returns Promise
 * @params id
 */
export const getUpCount = (params) => axiosApi.post(`/api/Patentapi/getUpCount `, params)


/**
 * @description 获取绑定的id数组
 * @returns Promise
 * @params id
 */
export const getAllCaseId = (params) => axiosApi.post(`/api/monitor/getAllCaseId `, params)

/**
 * @description 客服聊天获取前五条数据
 * @returns Promise
 * @params id
 */
export const getWxChatDataAccBefore = (params) => axiosApi.post(`/api/Service/getWxChatDataAccBefore `, params)

/**
 * @description 客服聊天获取前五条数据
 * @returns Promise
 * @params id
 */
export const getWxChatDataAcc = (params) => axiosApi.post(`/api/Service/getWxChatDataAcc?p=${params.page}`, params)







